var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.detailInfo.goods_attr)?_c('div',{staticClass:"main-content"},[_c('flex-line',{attrs:{"is-link":true,"show-border":true},nativeOn:{"click":function($event){return _vm.changeAttrState()}}},[_c('span',[_vm._v("参数")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }